import { lazy, useCallback } from "react";
import { CellChange, ChangeSource } from "handsontable/common";


const SpreadsheetEditor = lazy(() => import('@components/datatable/SpreadsheetEditor.component'));

interface Props {
    seedId: string;
    seedData: string[][];
    seedHeaders: string[];
    onChangeData: (data: string[][]) => void;
}
const SeedEditor = ( props: Props) => {

    const tableDataChanged = useCallback((changes: CellChange[] | null, source: ChangeSource) => {
        if (changes) {
            // Create a copy
            const copied = props.seedData.map(row => row.map(cell => cell));
            changes.forEach(([rowIdx, colIdx, oldVal, newVal]) => {
                copied[rowIdx][colIdx as number] = newVal;
            });
            props.onChangeData(copied);
            
            
        }
    }, [props.seedData, props.onChangeData]);

    return <div>
        <SpreadsheetEditor
            data={props.seedData}
            colHeaders={props.seedHeaders}
            afterChange={tableDataChanged}
        />
        

    </div>
}

export default SeedEditor;

